import { render, staticRenderFns } from "./ProjectGroupList.vue?vue&type=template&id=0869fcf5&scoped=true&"
import script from "./ProjectGroupList.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGroupList.vue?vue&type=style&index=0&id=0869fcf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0869fcf5",
  null
  
)

export default component.exports